const initialState = {
  languages: ["ja"],
  room_type: '',
  room_title: {
    ja: ''
  },
  house_rule: {
    ja: ''
  },
  description: {
    ja: ''
  },
  size: 0,
  maximum_guests: 0,
  beds: 0,
  bedrooms: 0,
  bathrooms: 0,
  bathtubs: 0,
  is_shared_bath: false,
  law_type: '',
  reservation_requirement: {
    accept_days: 0,
    checkin_from: 0,
    checkin_to: 0,
    checkout_to: 0,
    interval_days: 0,
    minimum_stays: 0,
    maximum_stays: 0,
    is_able_onsite_payment: false,
    is_instant_booking: false,
    address_required: false,
    is_pay_at_hotel: false
  },
  basic_price_setting: {
    persons_for_extra_fee: 0,
    price_for_extra_person: 0,
    weekly_discount: 0
  },
  property: {
    title: {
      ja: ''
    },
    lat: "35.683902",
    lon: "139.767009",
    description: {
      ja: ''
    },
    prefecture: '',
    city: '',
    street_address: '',
    address: '',
    country_code: '',
    country: ''
  },
  available_room_codes: [],
  bed_types: [],
  cancel_policy: '',
  photos: [],
  user: {
    nickname: '',
    confirmed_at: "2018-03-15T00:00:00.000Z",
    area: '',
    photo_url: '',
    introduction: '',
    supported_languages: []
  },
  amenities_list: [],
  typical_house_rules: [],
  home_safeties: [],
  // TODO: remove after convert to new format
  amenities: [],
  house_rules: [],
  home_safety: {
    check_list: []
  },
  review_stats: {}
}

export default function main(state = initialState, action){
  switch(action.type) {
  case 'SET_STATE_LISTING':
    const setValue = (src, def) => {
      for (let key of Object.keys(src)) {
        if (src[key] != null && typeof src[key] == 'object' && !(src[key] instanceof Array)) {
          src[key] = setValue(src[key], def[key])
        } else if (src[key] == null && def[key] != null) {
          src[key] = def[key]
        }
      }
      return src
    }
    return Object.assign({}, state, setValue(action.params, initialState))
  case 'ERROR':
    return Object.assign({}, state, { error: Object.assign({}, state.error, { [action.element]: action.message }) })
  default:
    return state
  }
}
